import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../components/ui/accordion";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {}); }, []);
  const grouped = faqs.reduce((acc, f) => { (acc[f.category] = acc[f.category] || []).push(f); return acc; }, {});

  return (
    <div className="luxy-container py-16 sm:py-24 max-w-3xl">
      <div className="text-center mb-14">
        <p className="eyebrow mb-3">Help & Information</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-pitch tracking-tight">Frequently Asked Questions</h1>
      </div>
      {Object.entries(grouped).map(([cat, items]) => (
        <div key={cat} className="mb-10">
          <h2 className="font-serif text-2xl text-pitch mb-4">{cat}</h2>
          <Accordion type="single" collapsible>
            {items.map((f) => (
              <AccordionItem key={f.id} value={f.id} className="border-linen">
                <AccordionTrigger className="text-left text-base font-sans" data-testid="faq-item">{f.question}</AccordionTrigger>
                <AccordionContent className="text-sm text-charcoal/80 leading-relaxed">{f.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      ))}
      {faqs.length === 0 && <p className="text-center text-stonemuted">No FAQs available yet.</p>}
    </div>
  );
}
